<ng-template *ngIf="(minimal && doctor.hasBookings) || (isMobile$ | async) === false" [ngTemplateOutlet]="CardHeader"></ng-template>
<div class="no-panel-padding-card" *ngIf="!(minimal && doctor.hasBookings) && (isMobile$ | async)">
  <ng-template [ngTemplateOutlet]="CardHeader"></ng-template>
</div>
<ng-template #CardHeader>
  <div class="doctor-card">
    <div class="profile-picture-container" (click)="saveDoctor()">
      <gc-profile-picture [ngClass]="{ primary: doctor.uuid }" [fullName]="doctor.fullName" [imgSrc]="doctor.logo"></gc-profile-picture>
      <mat-icon
        *ngIf="isAuthed$ | async"
        [class.primary]="!doctor.uuid"
        [class.secondary]="doctor.uuid"
        [class.selected]="isSaved"
        svgIcon="star"
      ></mat-icon>
    </div>
    <div class="doctor-row">
      <div class="doctor-details">
        <div class="mat-overline">
          <span *ngIf="doctor.distance">{{ 'distance_away' | translate: { distance: (doctor.distance | distance) } }}</span>
          <span *ngIf="doctor.practiceName" title="Practice Details">{{ doctor.practiceName }}</span>
          <ng-container *ngIf="!minimal">
            <button mat-icon-button class="extra-small" color="primary" *ngFor="let bookingType of filterBookingTypes(doctor.bookingTypes)">
              <mat-icon [svgIcon]="bookingType.icon"></mat-icon>
            </button>
          </ng-container>
          <button
            *ngIf="doctor.secureMessageEnabled"
            mat-icon-button
            class="extra-small"
            color="primary"
            matTooltipPosition="above"
            matTooltipClass="tooltip-primary"
            matTooltip="{{ 'secure_message' | translate }}"
            (click)="openSecureMessage()"
          >
            <mat-icon svgIcon="forum-outline"></mat-icon>
          </button>
        </div>
        <span class="centered">
          <span class="doctor-name">{{ doctor.diaryName }}</span>
          <span class="doctor-service">{{ doctor.service }}</span>
          <span *ngIf="timezone" class="doctor-timzone">
            {{ 'cancel_by_hours_prior' | translate: { hours: doctor.cancellationHours } }}
          </span>
          <span *ngIf="timezone" class="doctor-timzone">{{ 'time_zone' | translate: { timezone: timezone } }}</span>
        </span>
      </div>
      <gc-communication-actions
        class="action-card"
        [iconOnly]="true"
        [landlines]="doctor.landlines"
        [googleMapsLink]="doctor.googleMapsLink"
        [emailAddress]="doctor.emailAddress"
        [website]="doctor.website"
        [secureMessageEnabled]="doctor.secureMessageEnabled"
        [review]="doctor.allowReviews"
        [diaryUuid]="doctor.uuid"
      ></gc-communication-actions>
    </div>
    <div>
      <div *ngIf="bookingButton" class="booking-button-container">
        <button mat-raised-button color="primary" *ngIf="doctor.uuid" class="make-booking" (click)="makeBooking(doctor.uuid)">
          <mat-icon svgIcon="calendar"></mat-icon>
          {{ 'make_booking' | translate }}
        </button>
      </div>
      <div *ngIf="minimal">
        <button
          *ngIf="doctor.uuid; else NoBookings"
          mat-mini-fab
          class="minimal-make-booking"
          type="button"
          (click)="makeBooking(doctor.uuid)"
        >
          <mat-icon svgIcon="chevron-right"></mat-icon>
        </button>
        <ng-template #NoBookings>
          <gc-communication-actions
            class="hide-md"
            [iconOnly]="true"
            [landlines]="doctor.landlines"
            [googleMapsLink]="doctor.googleMapsLink"
            [emailAddress]="doctor.emailAddress"
            [website]="doctor.website"
            [secureMessageEnabled]="doctor.secureMessageEnabled"
            [review]="doctor.allowReviews"
            [diaryUuid]="doctor.uuid"
          ></gc-communication-actions>
        </ng-template>
      </div>
    </div>
  </div>
</ng-template>
